<template>

  <ul class="bdms text-left !p-0 mt-40">
    <li v-for="item of bdms" :key="item.id" class="lg:grid lg:grid-cols-12 lg:gap-14 mb-60 list-none">
      <div class="lg:col-span-5">
        <img :src="item.photo" class="w-full mb-30 lg:mb-0" />
      </div>
      <div class="text-blue lg:col-span-7">
        <h2 class="text-40 font-bold mb-20">{{ item.title }}</h2>
        <h3 class="text-27 font-semibold mb-20">{{ item.role }}</h3>
        <p class="text-20 mb-30">{{ item.bio }}</p>
        <div class="md:grid md:grid-cols-2 text-20 font-semibold">
          <div class="mb-30 md:mb-0">
            <span class="flex items-center mb-30">
              <img src="/partner/wp-content/uploads/2022/06/phone-bdm.svg" alt="" class="max-w-[17px] mr-20" />
              <a :href="'tel:' + item.tel" class="text-blue hover:text-orange">{{ item.tel }}</a>
            </span>
          </div>
          <div>
            <span class="flex items-center mb-30">
              <img src="/partner/wp-content/uploads/2022/06/email-bdm.svg" alt="" class="max-w-[21px] mr-20"  />
              <a :href="'mailto' + item.email" class="text-blue hover:text-orange"> {{ item.email }}</a>
            </span>
          </div>
          <a
            class="btn inline-block bg-orange text-white font-bold !px-20 !pr-30 w-full sm:max-w-[180px] mb-20"
            href="/partner/quick-enquiry/">Quick enquiry</a
          >
          <a
            class="btn inline-block bg-orange text-white font-bold !px-20 !pr-30 w-full sm:max-w-[180px] mb-20"
            href="/partner/request-a-visit/">Book a visit</a
          >
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    bdms: Array,
  },
  data() {
    return {};
  },
};
</script>
